<template>
  <div class="ma-4 d-flex flex-column">
    <div class="content-wrapper">
      <div class="ml-8">
        <lottie-player
          :animation-data="tickAnimation"
          :loop="true"
          :autoplay="true"
        />
      </div>

      <div class="check-in-clock-style">
        <check-in-clock />
      </div>
      <div
        v-if="anyCheckInAvailable"
        class="d-flex flex-column"
      >
        <v-btn
          v-if="anyCheckInAvailable"
          class="view-all-btn mt-3 px-7"
          elevation="0"
          f
          @click="toCheckOut()"
        >
          Check-out <v-icon x-small>
            mdi-arrow-top-right
          </v-icon>
        </v-btn>
        <v-btn
          v-if="anyCheckInAvailable"
          class="view-all-btn2 mt-3 px-7"
          elevation="0"
          @click="toOvertime()"
        >
          Overtime
        </v-btn>
      </div>
      <div
        v-else
        class="empty-alert-div"
      >
        <v-card
          color="#E2E2E2"
          elevation="0"
        >
          <br>
          <br>
          <p class="empty-alert-msg">
            <v-icon
              size="25"
              color="#C62828"
            >
              mdi-information-outline
            </v-icon>
            No records found
          </p>
          <br>
          <br>
        </v-card>
      </div>
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import spinner from '../../components/SpinnerCentre.vue';
import moment from 'moment';
import CheckInClock from './CheckInClock.vue';
import Constants from 'src/constants';
import LottiePlayer from './LottiePlayer.vue';
import tickAnimation from '../../../assets/timerclock.json';

export default {
  name: 'CheckoutNotifyPage',
  components: {
    'centre-spinner': spinner,
    'check-in-clock': CheckInClock,
    LottiePlayer,
  },
  filters: {
    convertToLocal (stringDatetime) {
      return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
    },
    arrangePretty (val) {
      if (val === 'staff') {
        return 'Site Manager';
      } else {
        return val;
      }
    },
  },
  data: () => ({
    loading: false,
    tickAnimation: JSON.parse(JSON.stringify(tickAnimation)),
  }),
  computed: {
    userCurrentCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    anyCheckInAvailable () {
      if (Object.keys(this.userCurrentCheckInDetails).length !== 0) {
        return true;
      }
      return false;
    },
  },
  async mounted () {
    this.loading = true;
    await this.getUserCurrentCheckInDetails();
    this.loading = false;
  },
  methods: {
    getUserCurrentCheckInDetails () {
      this.$store.dispatch('swiftuser/fetchUsersCurrentCheckInDetails');
    },
    toCheckOut () {
      if (this.anyCheckInAvailable === false) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'No check-in records found.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      this.$router.push({ name: 'CheckOut' });
    },
    async toOvertime () {
      await this.$store.dispatch('swiftuser/startOvertime', {
        pay_rule_settings_id: this.userCurrentCheckInDetails.next_pay_rule_settings.id,
        checkInId: this.userCurrentCheckInDetails.id,
      })
      .then({

      });
    },
  },
};
</script>

<style scoped>
.check-in-clock-style {
  padding-top: 35px;
  padding-bottom: 35px;
  border: 1px solid #37474f;
  border-radius: 15px !important;
  overflow: hidden;
  z-index: 1;
  text-align: center;
}
.check-out-btn {
  float: right;
}
.content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 85vh;
}
</style>
